import { useEditor } from '@smartfire/js-block-engine';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import clsx from 'clsx';
import { ReactComponent as Arrow } from './arrow.svg';
import style from './style.module.scss';

export const PublicationTile = ({ post, index }) => {
    const { isEditing } = useEditor();
    const url = post.url;
    const Tag = isEditing ? 'p' : 'a';

    return (
        <div className={clsx(style.post, style['position' + index])}>
            <Tag href={url} target="_blank" rel="noreferrer">
                <div className={style.thumbnailWrapper}>
                    <LazyLoadImage
                        effect={'opacity'}
                        wrapperClassName={style.thumbnail}
                        src={post.thumbnail.src}
                        alt={post.thumbnail.alt}
                    />

                    {post.category.icon && (
                        <div className={style.icon}>
                            <img src={post.category.icon.url} alt={post.category.name} />
                        </div>
                    )}

                    <Arrow className={style.arrow} />
                </div>
            </Tag>

            {index && <p className={style.rank}>0{index}</p>}

            <div className={style.title}>{post.post_title}</div>
            {post.post_excerpt && <div className={style.excerpt}>{post.post_excerpt}</div>}
            <Tag className={style.link} href={url} target="_blank" rel="noreferrer">
                Consulter
            </Tag>
        </div>
    );
};
